import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AgentConnectCard from "../common/AgentConnectCard/AgentConnectCard";
import AgentOverviewCard from "../common/AgentOverviewCard/AgentOverviewCard";
import AgentPropertiesCard from "../common/AgentPropertiesCard/AgentPropertiesCard";
import AgentReviewsCard from "../common/AgentReviewsCard/AgentReviewsCard";
import AgentContactCard from "../common/AgentContactCard/AgentContactCard";
import AgentAboutCard from "../common/AgentAboutCard/AgentAboutCard";
import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import isEmpty from "../common/utils/isEmpty";
import Review from "../common/Review/Review";
import HeaderImg from "../../assets/findAgent/headerImg.webp";
import AgentProfileInfo from "../common/AgentProfileInfo/AgentProfileInfo";

const AgentProfile = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const targetDivRef = useRef(null);
  const scrollToDiv = () => {
    targetDivRef.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });
  };
  const Tags = ["Professional (0)", "Great communicator (0)", "Genuine (0)"];
  const [allAgentData, setAllAgentData] = useState({});

  const [AgentData, setAgentData] = useState({});
  const [isAgentLoading, setIsAgentLoading] = useState(true);
  //console.log("🚀 ~ AgentProfile ~ AgentData:", AgentData);
  //console.log(
  //   "🚀 ~ AgentProfile ~ AgentData-----------------id:",
  //   AgentData?.agency_id?._id
  // );

  const [property, setProperty] = useState({});
  const [isActive, setisActive] = useState("");

  const AgentProfileSkeleton = () => (
    <div className="bg-[#F6F5F7] py-[14px] px-2 md:px-0 animate-pulse">
      <div className="bg-gray-200 h-10 rounded-none" />
      <div className="bg-gray-200 w-full h-[210px] md:h-[370px]" />
      <div className="bg-white py-10 px-2 md:px-0">
        <div className="container mx-auto flex flex-col md:flex-row gap-8 items-start md:items-center">
          <div className="w-[100px] md:w-[135px] h-[100px] md:h-[135px] rounded-full bg-gray-200" />
          <div className="flex-1 space-y-3">
            <div className="h-10 bg-gray-200 rounded w-56" />
            <div className="h-4 bg-gray-200 rounded w-full max-w-[420px]" />
            <div className="h-4 bg-gray-200 rounded w-72" />
            <div className="h-4 bg-gray-200 rounded w-64" />
            <div className="h-4 bg-gray-200 rounded w-80" />
          </div>
          <div className="w-full md:w-[260px] space-y-3">
            <div className="h-12 bg-gray-200 rounded-full w-full" />
            <div className="flex gap-3">
              <div className="h-12 bg-gray-200 rounded-full flex-1" />
              <div className="h-12 bg-gray-200 rounded-full flex-1" />
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto mt-6">
        <div className="grid grid-cols-1 xl:grid-cols-8 gap-[60px] mb-10">
          <div className="w-full grid col-span-1 xl:col-span-6 2xl:col-span-9 space-y-8">
            <div className="h-28 bg-gray-200 rounded-2xl" />
            <div className="h-28 bg-gray-200 rounded-2xl" />
            <div className="h-28 bg-gray-200 rounded-2xl" />
            <div className="h-28 bg-gray-200 rounded-2xl" />
          </div>
          <div className="hidden xl:block xl:col-span-2 2xl:col-span-3 sticky top-5">
            <div className="h-[460px] bg-gray-200 rounded-2xl" />
          </div>
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-4 gap-6 mt-6">
          <div className="xl:col-span-3 h-44 bg-gray-200 rounded-2xl" />
          <div className="xl:col-span-1 h-44 bg-gray-200 rounded-2xl" />
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    setIsAgentLoading(true);
    GetAgentData(id);
  }, [id]);

  const GetAgentData = async (id) => {
    await axiosInstanceAuth
      .post(`Agency_Agent/ViewProfile`, {
        id: id,
      })
      .then((res) => {
        const allAgentData = res?.data;
        setAllAgentData(allAgentData);
        const mydata = res?.data?.data;

        // //console.log("-->>>Agency_Agent/ViewProfile", mydata);
        if (res?.data?.status) {
          setAgentData(mydata);
          setProperty(res?.data?.property);
        } else {
          // toast.error("Oops! Something went wrong");
        }
      })
      .catch((err) => {
        //console.log("err --->", err);
      })
      .finally(() => setIsAgentLoading(false));
  };

  const responce = isEmpty(AgentData);
  let averageRatings = 0;

  const getReviewsData = () => {
    for (var i = 0; i < AgentData?.reviews.length; i++) {
      averageRatings += Number(AgentData?.reviews[i].star);
    }
    return (averageRatings /= Number(AgentData?.reviews.length));
  };

  if (!responce) {
    if (AgentData?.reviews?.length !== 0) getReviewsData();
  }

  if (isAgentLoading) return <AgentProfileSkeleton />;

  return (
    <div>
      <AgentProfileInfo AgentData={AgentData} navigate={navigate} scrollToDiv={scrollToDiv} />

      <div className="bg-[#F6F5F7] py-[14px] px-2 md:px-0">
        <div className="container">
          {/* <AgentOverviewCard AgentData={allAgentData} property={property} /> */}
          {/*  mobile view component */}
          <div className=" w-full md:hidden ">
            <AgentConnectCard
              AgentData={AgentData}
              averageRatings={averageRatings}
              scrollToDiv={scrollToDiv}
              isDesktop={false}
              isMobile={true}
            />
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-8 2xl:grid-cols-12 place-content-center xl:place-items-start gap-[60px] mb-10">
            <div className="w-full grid col-span-1 xl:col-span-6 2xl:col-span-9">
              <div className="">
                <AgentOverviewCard
                  AgentData={allAgentData}
                  property={property}
                />
              </div>

              {/* ------ Properties ------ */}
              <div className="mt-4 md:mt-8">
                <AgentPropertiesCard
                  AgentData={AgentData}
                  property={property}
                />
              </div>

              {/* ------ About card ------ */}
              <div className="mt-5">
                <AgentAboutCard AgentData={AgentData} />
              </div>

              {/* ------ Reviews ------ */}
              <div className="mt-5">
                <AgentReviewsCard
                  AgentData={AgentData}
                  averageRatings={averageRatings}
                />
              </div>

              {/* ------ Contact card ------ */}
              <div id="Contact" ref={targetDivRef} className="mt-4">
                <AgentContactCard
                  AgentData={AgentData}
                  averageRatings={averageRatings}
                />
              </div>
            </div>
            {/*  Desktop view component */}
            <div className="hidden w-full xl:grid col-span-1 2xl:col-span-3 xl:col-span-2 sticky top-5">
              <AgentConnectCard
                AgentData={AgentData}
                averageRatings={averageRatings}
                scrollToDiv={scrollToDiv}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentProfile;
